const LOCALE = "pt-BR";
let DEFAULT_CCY = "USD";
export const setDefaultCurrency = (c) => { DEFAULT_CCY = c || "USD"; };
export const getDefaultCurrency = () => DEFAULT_CCY;
export const ccySymbol = (c = DEFAULT_CCY) => (c === "EUR" ? "€" : "US$");

export const fmtMoney = (v, ccy = DEFAULT_CCY) =>
  v == null ? "—" : new Intl.NumberFormat(LOCALE, { style: "currency", currency: ccy, minimumFractionDigits: 2 }).format(v);

export const fmtPrice = (v, d = 2) =>
  v == null ? "—" : new Intl.NumberFormat(LOCALE, { minimumFractionDigits: d, maximumFractionDigits: d }).format(v);

export const fmtPct = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${v.toFixed(2).replace(".", ",")}%`);

export const fmtSigned = (v, ccy = DEFAULT_CCY) => (v == null ? "—" : `${v > 0 ? "+" : ""}${fmtMoney(v, ccy)}`);

export const fmtCompact = (v) =>
  v == null ? "—" : new Intl.NumberFormat(LOCALE, { notation: "compact", maximumFractionDigits: 2 }).format(v);

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString(LOCALE, { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString(LOCALE, { hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "—");

export const pnlClass = (v) => (v > 0 ? "up" : v < 0 ? "down" : "text-muted-foreground");

export const TX_STATUS = {
  requested: { label: "Solicitado", tone: "info" },
  under_review: { label: "Em análise", tone: "warn" },
  confirmed: { label: "Confirmado", tone: "up" },
  rejected: { label: "Recusado", tone: "down" },
  cancelled: { label: "Cancelado", tone: "muted" },
};

export const ACCOUNT_STATUS = {
  pending: { label: "Pendente", tone: "warn" },
  active: { label: "Ativa", tone: "up" },
  under_review: { label: "Em análise", tone: "info" },
  suspended: { label: "Suspensa", tone: "down" },
  closed: { label: "Encerrada", tone: "muted" },
};

export const ORDER_STATUS = {
  pending: { label: "Pendente", tone: "warn" },
  filling: { label: "Executando", tone: "info" },
  filled: { label: "Executada", tone: "up" },
  cancelled: { label: "Cancelada", tone: "muted" },
  rejected: { label: "Rejeitada", tone: "down" },
};

export const DOC_STATUS = {
  pending: { label: "Em análise", tone: "warn" },
  approved: { label: "Aprovado", tone: "up" },
  rejected: { label: "Recusado", tone: "down" },
  none: { label: "Não enviado", tone: "muted" },
};

export const ORDER_TYPE = { market: "Mercado", limit: "Limitada", stop: "Stop" };
export const SIDE = { buy: "Compra", sell: "Venda" };
export const LEDGER_KIND = {
  demo_credit: "Crédito virtual (demo)", admin_credit: "Crédito do administrador", admin_debit: "Retirada pelo administrador", currency_change: "Conversão de moeda", deposit: "Depósito", withdrawal: "Saque", commission: "Comissão", trade_pnl: "Resultado de operação",
};
export const CLOSE_REASON = { manual: "Manual", stop_loss: "Stop Loss", take_profit: "Take Profit" };
export const CATEGORY_LABEL = { forex: "Forex", crypto: "Criptomoedas", stocks: "Ações", indices: "Índices", commodities: "Commodities" };
export const DOC_TYPES = { rg: "RG", cnh: "CNH", passaporte: "Passaporte", comprovante_residencia: "Comprovante de residência", outro: "Outro" };
export const PERMISSIONS = {
  clients: "Clientes", finance: "Financeiro", trading: "Negociação", documents: "Documentos",
  notifications: "Notificações", assets: "Ativos", reports: "Relatórios", admins: "Administradores",
};
